import {Observable} from 'rxjs/Rx';
import {HttpRequest, HttpResponse} from '@angular/common/http';
/**
 * @abstract
 */
export abstract class Requestable {
/**
 * @abstract
 * @param {?} request
 * @return {?}
 */
request(request: HttpRequest<any>) {}
}
